import { SerialChartDrawOption } from '@/modules/ta/widget/models/drawoptions/SerialChartDrawOption';
import { PlotType } from '@/modules/ta/widget/widget.constants';
import { GradientTypes } from '@/modules/ta/widget/builder.constants';

export class BarChartDrawOption extends SerialChartDrawOption {
  /**
   * @var {number}
   */
  width;

  /**
   * @var {number}
   */
  rounded_corners;

  /**
   *
   * @type {Boolean}
   */
  show_column_shadows;

  /**
   * @var {string}
   */
  fill_type;

  /**
   * @var {string}
   */
  gradient_color;

  /**
   * @var {Boolean}
   */
  curved_columns;

  /**
   * @var {number}
   */
  radial_inner_radius;

  constructor(model = {}) {
    super(model);
    this.width = model.width;
    this.rounded_corners = model.rounded_corners ?? 0;
    this.show_column_shadows = model.show_column_shadows ?? false;
    this.fill_type = model.fill_type ?? GradientTypes.SOLID;
    this.gradient_color = model.gradient_color ?? null;
    this.curved_columns = model.curved_columns ?? false;
    this.radial_inner_radius =
      model.radial_inner_radius > 60 ? 60 : model.radial_inner_radius ?? 40;
  }

  setValidPlotType(model) {
    const validTypes = [
      PlotType.CLUSTERED,
      PlotType.STACKED,
      PlotType.FULL_STACKED,
      PlotType.DEEP_STACKED,
      PlotType.CLUSTERED_V2,
      PlotType.STACKED_V2,
      PlotType.FULL_STACKED_V2,
      PlotType.LAYERED_V2,
      PlotType.LOLLIPOP_V2,
      PlotType.RADIAL_HISTOGRAM_V2,
      PlotType.RADIAL_BAR_V2,
    ];

    if (!model.plot_type || !validTypes.includes(model.plot_type)) {
      this.plot_type = PlotType.CLUSTERED_V2;
    } else {
      this.plot_type = model.plot_type;
    }
  }
}
